<template>
  <div>

<h2 class="goth">Perfekt av svaga verb</h2>
<div class="grammatikparagrafbredd leftorient">
<h4>Vad är perfekt</h4>
          <p>Perfekt ("har"-form) är en tidsform i dåtid som på svenska bildas med hjälpverbet
              <i>har</i> samt verbformen <i>supinum</i>.</p><br>

              <div class="quasi-p">
              <div class="p-stil"><div class="upp"><i>Jag </i></div><div class="dubbelrad"><u><i>har</i></u> &nbsp; &nbsp; &nbsp; <br><div class="minitext">hjälpverb</div></div></div>
              <div class="p-stil"><div class="dubbelrad"><u><i> spelat.</i></u>&nbsp; &nbsp;&nbsp;<br><div class="minitext">supinum</div></div></div>

              </div>

              <br><p>I de enklaste fallen bildar tyskan perfekt på liknande sätt med hjälpverbet
                  <i>haben</i> samt verbformen som på tyska kallas <i>perfektparticip</i>.</p><br>

                  <div class="quasi-p">
                  <div class="p-stil"><div class="upp"><i>Ich </i></div><div class="dubbelrad"><u><i>habe</i></u> &nbsp;&nbsp;&nbsp;  <br><div class="minitext">hjälpverb</div></div></div>

                  <div class="p-stil"><div class="dubbelrad"><u><i> <b>ge</b>spiel<b>t</b>.</i></u>&nbsp; &nbsp;&nbsp;<br><div class="minitext">perfektparticip</div></div></div>

                  </div>

<br><h4>Ordföljd i perfekt</h4>
<div class="quasi-p">Observera att ordföljden är litet annorlunda än i svenskan. I tyska <div class="understryk-gron">huvudsatser</div> i perfekt hamnar alltid
<div class="understryk-gron">perfektparticipen SIST</div> i satsen.</div>
<br>

<div class="ruta">
<div class="quasi-p">
<div class="p-stil"><div class="upp"><i>Ich </i></div><div class="dubbelrad"><u><i>habe</i></u> &nbsp;  <br><div class="minitext">hjälpverb</div></div></div>
<div class="upp"><i>ein Auto </i></div>
<div class="p-stil"><div class="dubbelrad"><u><i> <b>ge</b>kauf<b>t</b>.</i></u>&nbsp; &nbsp;&nbsp;<br><div class="minitext">perfektparticip</div></div></div>
<br><br>
<div class="p-stil"><i>Jag har köpt en bil.</i></div>

</div>
</div>

<br>
<br>

<div class="quasi-p">I <div class="understryk-rod">bisatser</div> hamnar dock <div class="understryk-rod">hjälpverbet sist</div> eftersom det finita (personböjda) verbet alltid hamnar sist i tyska bisater.</div>
<br>

<div class="ruta">
    <div class="quasi-p">
    <div class="p-stil"><div class="upp"><i class="gra">Weißt du, </i> <i>dass ich ein Auto </i></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> <b>ge</b>kauf<b>t</b></i></u>&nbsp; &nbsp;&nbsp;<br><div class="minitext">perfektparticip</div></div></div>
    <div class="dubbelrad"><u><i>habe.</i></u> &nbsp;  <br><div class="minitext">hjälpverb</div></div></div>
    </div>

    <div class="quasi-p">
    <div class="p-stil"><div class="upp"><i class="gra">Vet du, </i> <i>att jag </i></div><div class="dubbelrad"><u><i>har</i></u> &nbsp; &nbsp; &nbsp; <br><div class="minitext">hjälpverb</div></div></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> köpt</i></u>&nbsp; &nbsp;&nbsp;<br><div class="minitext">supinum</div></div></div>
    <div class="upp"><i>en bil.</i></div>
    </div>

</div>

<br><h4>Hjälpverbet böjs, perfektparticip oförändrat</h4>
<p>Perfektparticipformen böjs inte efter person (<i>subjektet</i>, den som gör), utan det är istället hjälpverbet som böjs.</p>
<br>


</div>

    <table class="">

        <tr class="leftorient">
            <th class="ljusgra">&nbsp;subjekt&nbsp;</th>
            <th class="ljusgra">&nbsp;hjälpverb&nbsp;</th>

            <th class="ljusgra">&nbsp;perfektparticip&nbsp;</th>

        </tr>
<tr></tr>

        <tr class="leftorient">
            <td class="ljusgra"><i>ich</i></td>
            <td class="ljusgra"><i><b>habe</b></i></td>

            <td class="ljusgra"><i>gespielt</i></td>

        </tr>

        <tr class="leftorient">
            <td  class="ljusgra"><i>du</i></td>
            <td  class="ljusgra"><i><b>hast</b></i></td>

            <td  class="ljusgra"><i>gespielt</i></td>
        </tr>

        <tr class="leftorient">
            <td  class="ljusgra"><i>er<br> es<br> sie</i></td>
            <td  class="ljusgra"><i><b>hat</b></i></td>

            <td  class="ljusgra"><i>gespielt</i></td>
        </tr>

<tr></tr>

        <tr class="leftorient">
            <td  class="ljusgra upperspace"><i>wir</i></td>
            <td  class="ljusgra"><i><b>haben</b></i></td>

            <td  class="ljusgra"><i>gespielt</i></td>
        </tr>

        <tr class="leftorient">
            <td  class="ljusgra"><i>ihr</i></td>
            <td  class="ljusgra"><i><b>habt</b></i></td>

            <td  class="ljusgra"><i>gespielt</i></td>
        </tr>

        <tr class="leftorient">
            <td  class="ljusgra"><i>sie<br> Sie</i></td>
            <td  class="ljusgra"><i><b>haben</b></i></td>

            <td  class="ljusgra"><i>gespielt</i></td>
        </tr>


    </table>


<div class="grammatikparagrafbredd leftorient">
<br>
<h4>Hur bildas perfektparticip-formen</h4>
<div class="quasi-p p-stil">Perfektparticipformen av svaga verb bildas i regel genom
<div class="understryk-gul"><nobr> &nbsp;<b> ge</b> + [verbstam] + <b>t </b>&nbsp;</nobr></div>.</div>
<br><br>

<table class="">

    <tr class="leftorient">
        <th  class="ljusgra">
        <th class="ljusgra">infinitiv</th>
        <th class="ljusgra">perfekt</th>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">köpa</td>
        <td class="ljusgra"><i>kauf</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>kauf<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">spela</td>
        <td class="ljusgra"><i>spiel</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>spiel<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">göra</td>
        <td class="ljusgra"><i>mach</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>mach<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">bo</td>
        <td class="ljusgra"><i>wohn</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>wohn<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">köpa</td>
        <td class="ljusgra"><i>kauf</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>kauf<b>t</b></i></td>
    </tr>

</table>


<br><br>
<p>Ibland skjuts ett <b>-e-</b> in mellan verbstam och t för uttalets skull.</p>

<table class="">

    <tr class="leftorient">
        <th class="ljusgra">
        <th class="ljusgra">infinitiv</th>
        <th class="ljusgra">perfekt</th>
    </tr>


    <tr class="leftorient">
        <td class="ljusgra">arbeta</td>
        <td class="ljusgra"><i>arbeit</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>arbeit<b><div class="accented">e</div>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">bada</td>
        <td class="ljusgra"><i>bad</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>bad<b><div class="accented">e</div>t</b></i></td>
    </tr>

</table>
<br><br>
<p>Några verb i perfektparticip får inget <b>ge-</b> i början.
Det gäller verb vars första stavelse är obetonad. T.ex. verb som börjar på <b>be- er- ge- ent- ver-</b> eller slutar på <b>-ieren</b>
</p>

<table class="">

    <tr class="leftorient">
        <th class="ljusgra">
        <th class="ljusgra">infinitiv</th>
        <th class="ljusgra">perfekt</th>
    </tr>


    <tr class="leftorient">
        <td class="ljusgra">betala</td>
        <td class="ljusgra"><i>bezahl</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div> bezahl<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">uppleva</td>
        <td class="ljusgra"><i>erleb</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div> erleb<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">upptäcka</td>
        <td class="ljusgra"><i>entdeck</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div> entdeck<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">sakna</td>
        <td class="ljusgra"><i>vermiss</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div> vermiss<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">telefonera</td>
        <td class="ljusgra"><i>telefonier</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div> telefonier<b>t</b></i></td>
    </tr>

</table>

<p class="minitext">I tabellerna ovan har ett lodrätt streck | använts för att skilja verbstammen från infinitivändelsen.</p>
</div>

<br>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "perfekt svaga verb"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
